import { apiConfig } from './api-config.js';

// Función para buscar negocios inteligentes desde el frontend
export async function buscarNegociosInteligente(termino, categoria = '', ciudad = '', pais = '') {
  let url = `${apiConfig.baseURL}/search/items?q=${encodeURIComponent(termino)}`;
  if (categoria) url += `&categoria=${encodeURIComponent(categoria)}`;
  if (ciudad) url += `&ciudad=${encodeURIComponent(ciudad)}`;
  if (pais) url += `&pais=${encodeURIComponent(pais)}`;
  console.log('🔍 Buscando en:', url);
  try {
    const res = await fetch(url);
    console.log('📡 Respuesta HTTP:', res.status, res.statusText);
    if (!res.ok) {
      console.log('❌ Error HTTP:', res.status);
      return { results: [], etiquetas_encontradas: [], message: 'Error en la búsqueda' };
    }
    const data = await res.json();
    console.log('📦 Datos recibidos:', data);
    return data;
  } catch (err) {
    console.error('💥 Error buscando negocios:', err);
    return { results: [], error: err.message };
  }
}
